/**
 * Demo Mode Hook
 * 
 * Determines if the current user is in demo mode based on membership_type
 * Reuses the profile query cache to avoid duplicate network requests
 */

import { useQuery } from '@tanstack/react-query';
import { profileService } from '../services/profile-service';

/**
 * Hook to check if current user is in demo mode
 * 
 * Demo mode is determined by checking if user_profiles.membership_type === 'demo'
 * 
 * Performance: Uses the same ['profile'] query key as ProfilePage, so it shares
 * the cached profile data and doesn't make duplicate network requests.
 */
export function useDemoMode() {
  const { data: profile, isLoading } = useQuery({
    queryKey: ['profile'],
    queryFn: async () => {
      const result = await profileService.getProfile();
      if (result.error) {
        throw new Error(result.error.message);
      }
      return result.data;
    },
    retry: 1,
  });

  return {
    isDemoMode: profile?.membershipType === 'demo',
    loading: isLoading,
  };
}
